import React from 'react'
export const GHSvgIconPlus = () => {
    return(
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 18.75H21.25V10H18.75V18.75H10V21.25H18.75V30H21.25V21.25H30V18.75Z" fill="#242E30"/>
        </svg>
    );
}
